import { currentBrand, type BrandId } from "./tokens";

/**
 * Hardcoded brand display profiles (name, short name, tagline) behind ONE
 * interface. The experience/branding fixtures (partner logos, measured
 * display copy) are held out of the trunk pending a data-governance
 * ruling — nothing in the app should read branding from anywhere else.
 *
 * TODO(FN-G2): replace with measured experience fixtures when the corpus lands.
 */
export interface BrandProfile {
  id: BrandId;
  name: string;
  shortName: string;
  tagline: string;
}

const BRAND_PROFILES: Record<BrandId, BrandProfile> = {
  zw: {
    id: "zw",
    name: "ZoomWarriors",
    shortName: "ZW",
    tagline: "Scope. Quote. Close.",
  },
  vip: {
    id: "vip",
    name: "PSCX VIP",
    shortName: "VIP",
    tagline: "Voice Intelligence Platform",
  },
};

export function brandProfile(id: BrandId): BrandProfile {
  return BRAND_PROFILES[id];
}

/** Read the active brand profile off an element (usually document.documentElement). */
export function currentBrandProfile(root: Element): BrandProfile {
  return BRAND_PROFILES[currentBrand(root)];
}
